import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const getLinkedAccountsQueryKey = () => QueryClientHelper.makeQueryKey('/api/auth/linked-accounts', {});
//# sourceMappingURL=multiaccountKeys.js.map